import { render, staticRenderFns } from "./GPathrRoadmapExtraAdd.vue?vue&type=template&id=32663190&scoped=true"
import script from "./GPathrRoadmapExtraAdd.vue?vue&type=script&lang=js"
export * from "./GPathrRoadmapExtraAdd.vue?vue&type=script&lang=js"
import style0 from "./GPathrRoadmapExtraAdd.vue?vue&type=style&index=0&id=32663190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32663190",
  null
  
)

export default component.exports